import {
  CLEAR_GLOBAL_STATE,
  GET_SAFE_INFO,
  GET_SAFE_INFO_ERROR,
  GET_SAFE_INFO_SUCCESS,
  GET_V2_MIGRATION_STATUS,
  GET_V2_MIGRATION_STATUS_ERROR,
  GET_V2_MIGRATION_STATUS_SUCCESS,
  GET_V2_WAITLIST_STATUS,
  GET_V2_WAITLIST_STATUS_ERROR,
  GET_V2_WAITLIST_STATUS_SUCCESS,
  NUDGE_TO_V2,
  NUDGE_TO_V2_ERROR,
  NUDGE_TO_V2_SUCCESS,
  SET_DATA_SHARING,
  SET_GAS_MODE,
  SET_ORGANISATION_TYPE,
  SET_OWNERS_AND_THRESHOLD,
  SET_OWNER_DETAILS,
  SET_OWNER_NAME,
  SET_READ_ONLY,
  SET_SAFE_ADDRESS,
} from "./action-types";

export function setOwnerName(name) {
  return {
    type: SET_OWNER_NAME,
    name,
  };
}

export function setSafeAddress(safeAddress) {
  return {
    type: SET_SAFE_ADDRESS,
    safeAddress,
  };
}

export function setOwnerDetails(name, address, createdBy) {
  return {
    type: SET_OWNER_DETAILS,
    name,
    address, // safe address
    createdBy,
  };
}

export function setOwnersAndThreshold(owners, threshold) {
  return {
    type: SET_OWNERS_AND_THRESHOLD,
    owners,
    threshold,
  };
}

export function setOrganisationType(organisationType) {
  return {
    type: SET_ORGANISATION_TYPE,
    organisationType,
  };
}

export function setReadOnly(isReadOnly) {
  return {
    type: SET_READ_ONLY,
    isReadOnly,
  };
}

export function setDataSharingAllowed(dataSharingAllowed) {
  return {
    type: SET_DATA_SHARING,
    dataSharingAllowed,
  };
}

export function setGasMode(gasMode) {
  return {
    type: SET_GAS_MODE,
    gasMode,
  };
}

export function clearGlobalState() {
  return {
    type: CLEAR_GLOBAL_STATE,
  };
}

export function getSafeInfo(safeAddress, ownerAddress, isCached = 1) {
  return {
    type: GET_SAFE_INFO,
    safeAddress,
    ownerAddress,
    isCached,
  };
}

export function getSafeInfoSuccess({
  name,
  owners,
  threshold,
  isOwner,
  organisationType,
  safeAddress,
  dataSharingAllowed,
  version,
}) {
  return {
    type: GET_SAFE_INFO_SUCCESS,
    name,
    owners,
    threshold,
    isOwner,
    organisationType,
    safeAddress,
    dataSharingAllowed,
    version,
  };
}

export function getSafeInfoError(error) {
  return {
    type: GET_SAFE_INFO_ERROR,
    error,
  };
}

export function fetchNudgeToV2({ safeAddress, accountAddress, networkId }) {
  return {
    type: NUDGE_TO_V2,
    safeAddress,
    accountAddress,
    networkId,
  };
}

export function nudgeToV2Success({ nudge }) {
  return {
    type: NUDGE_TO_V2_SUCCESS,
    nudge,
  };
}

export function nudgeToV2Error(error) {
  return {
    type: NUDGE_TO_V2_ERROR,
    error,
  };
}

export function fetchV2MigrationStatus({ safeAddress, networkId }) {
  return {
    type: GET_V2_MIGRATION_STATUS,
    safeAddress,
    networkId,
  };
}

export function fetchV2MigrationStatusSuccess({ status }) {
  return {
    type: GET_V2_MIGRATION_STATUS_SUCCESS,
    status,
  };
}

export function fetchV2MigrationStatusError(error) {
  return {
    type: GET_V2_MIGRATION_STATUS_ERROR,
    error,
  };
}
export function fetchWhitelistStatus({ walletAddress }) {
  return {
    type: GET_V2_WAITLIST_STATUS,
    walletAddress,
  };
}

export function fetchWhitelistStatusSuccess({ flow, createOrganisation }) {
  return {
    type: GET_V2_WAITLIST_STATUS_SUCCESS,
    flow,
    createOrganisation,
  };
}

export function fetchWhitelistStatusError(error) {
  return {
    type: GET_V2_WAITLIST_STATUS_ERROR,
    error,
  };
}
